export default class Widget {
    constructor() {
        this.settings = {};
        this.cookieName = 'R.WidgetCookiesAccepted';
        this.bind();
    }

    bind() {
        document.addEventListener('DOMContentLoaded', () => {
            if (window.CookieWidgetSettings) {
                if (!this.hasCookie(this.cookieName)) {
                    this.settings = window.CookieWidgetSettings;
                    this.init();
                }
            }
        });
    }

    init() {
        const widgetVersion = this.settings.version;

        // Цепляем пустой контейнер к body
        const body = document.querySelector('body');
        const container = document.createElement('div');
        body.appendChild(container);

        // Открываем шадоу рут
        const shadowRoot = container.attachShadow({ mode: 'open' });

        // Засовываем туда линк на стили
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        if (this.settings.local) {
            link.href = `http://127.0.0.1:9000/${widgetVersion}/main.css`;
        } else {
            link.href = `https://cookie.rclass.pro/src/${widgetVersion}/main.css`;
        }
        shadowRoot.appendChild(link);

        shadowRoot.appendChild(this.createLink({
            rel: 'preconnect',
            href: 'https://fonts.googleapis.com '
        }));

        shadowRoot.appendChild(this.createLink({
            rel: 'preconnect',
            href: 'https://fonts.gstatic.com ',
            crossorigin: ''
        }));

        shadowRoot.appendChild(this.createLink({
            rel: 'stylesheet',
            href: 'https://fonts.googleapis.com/css2?family=Inter :wght@400;500;600;700&display=swap'
        }));

        // В шадоу рут суем контейнер для внутренностей
        const innerContainer = document.createElement('div');
        innerContainer.classList.add('cookie-widget');
        shadowRoot.appendChild(innerContainer);

        // Рендерим содержимое виджета
        setTimeout(() => {
            this.renderWidget(innerContainer);
        }, 3000);
    }

    renderWidget(innerContainer) {
        const style = this.settings.style === '2' ? '_corner' : '_wide';

        const mainContainer = document.createElement('div');
        mainContainer.classList.add('cookie-widget__approve-container');
        mainContainer.classList.add('_loading');
        mainContainer.classList.add(style);
        this.container = mainContainer;

        // Создаем текст с ссылкой
        const textElement = document.createElement('span');
        textElement.textContent = 'Мы обрабатываем ';

        const linkElement = document.createElement('a');
        linkElement.href = this.settings.cookiePolicyUrl || 'javascript:void(0);';
        linkElement.target = '_blank';
        linkElement.classList.add('cookie-widget__link');
        linkElement.textContent = 'cookie';

        textElement.appendChild(linkElement);
        textElement.append(' для улучшения вашего опыта взаимодействия с сайтом и аналитики посещений.');

        // Создаем кнопку
        const buttonElement = document.createElement('button');
        buttonElement.textContent = this.settings.buttonText || 'Хорошо';
        buttonElement.classList.add('cookie-widget__accept-button');

        // Собираем структуру
        this.container.appendChild(textElement);
        this.container.appendChild(buttonElement);

        innerContainer.appendChild(this.container);
        setTimeout(() => {
            this.container.classList.remove('_loading');
        }, 100);

        // Обработчик нажатия на кнопку
        buttonElement.addEventListener('click', () => {
            this.handleAccept(this.cookieName);
            this.container.classList.add('_loading');
            setTimeout(() => {
                this.container.remove();
            }, 500);
        });
    }

    createLink(attrs) {
        const link = document.createElement('link');
        Object.entries(attrs).forEach(([key, value]) => {
            link.setAttribute(key, value);
        });
        return link;
    }

    handleAccept(cookieName) {
        const cookieValue = 'true';
        const maxAgeInDays = 7;

        const maxAge = maxAgeInDays * 24 * 60 * 60;

        document.cookie = `${cookieName}=${cookieValue}; path=/; max-age=${maxAge}`;
    }

    hasCookie(cookieName) {
        return document.cookie.split(';').some(cookie => cookie.trim().startsWith(`${cookieName}=`));
    }
}